import styled from "styled-components";

export const Title = styled.h2`
  @media screen and (orientation: portrait) {
    font-size: 4.5vh;
    line-height: 4.6vh;
  }

  @media screen and (orientation: landscape) {
    font-size: 3vw;
    line-height: 3.1vw;
  }
`;
